import { render, staticRenderFns } from "./TtsModel.vue?vue&type=template&id=2a96b551&scoped=true"
import script from "./TtsModel.vue?vue&type=script&lang=js"
export * from "./TtsModel.vue?vue&type=script&lang=js"
import style0 from "./TtsModel.vue?vue&type=style&index=0&id=2a96b551&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a96b551",
  null
  
)

export default component.exports